import {createFormActionTypes} from "../../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../../shared/ts/helpers/create_form_actions";

export const HERO_FILTER_PREFIX = "hero/filter_list";
export const filterHeroListFormTypes = createFormActionTypes(HERO_FILTER_PREFIX);
export const filterHeroListFormActions = createFormActions(filterHeroListFormTypes);
